// Alpine.js component for equal height columns
window.contentFormBlockEqualColumnsHeight = function () {
  return {
    maxHeight: 0,

    init() {
      this.calculateHeight();
      window.addEventListener('resize', () => this.calculateHeight());

      // Submitting over AJAX swaps the form for its confirmation (or a
      // validation-error rerender) in place, so our pinned pixel heights stay
      // measured against the taller pre-submit form. gform_post_render fires for
      // those swaps too; rAF lets the new markup lay out before we re-measure.
      // jQuery is guarded because the block can render on a page without a form.
      if (window.jQuery) {
        window.jQuery(document).on('gform_post_render', () => {
          requestAnimationFrame(() => this.calculateHeight());
        });
      }
    },

    calculateHeight() {
      // Check if screen width is 760px or larger
      const mediaQuery = window.matchMedia('(min-width: 1200px)');

      if (this.$refs.column1 && this.$refs.column2) {
        if (mediaQuery.matches) {
          // Reset heights to auto to get natural heights
          this.$refs.column1.style.height = 'auto';
          this.$refs.column2.style.height = 'auto';

          // Get natural heights
          const height1 = this.$refs.column1.offsetHeight;
          const height2 = this.$refs.column2.offsetHeight;

          // Set max height
          this.maxHeight = Math.max(height1, height2);

          // Apply the height directly to both columns
          this.applyHeight();
        } else {
          // On smaller screens, remove height styling
          this.removeHeight();
        }
      }
    },

    applyHeight() {
      if (this.maxHeight > 0 && this.$refs.column1 && this.$refs.column2) {
        this.$refs.column1.style.height = `${this.maxHeight}px`;
        this.$refs.column2.style.height = `${this.maxHeight}px`;
      }
    },

    removeHeight() {
      if (this.$refs.column1 && this.$refs.column2) {
        this.$refs.column1.style.height = '';
        this.$refs.column2.style.height = '';
      }
      this.maxHeight = 0;
    },
  };
};
